<template>
  <div class="v-tariff-groups">
    <div class="modal-backdrop">
      <div class="modal">
        <header class="modal-header">
          <slot name="header">
            <h5>Группы тарифов</h5>
            <button type="button" class="btn-close" @click="close">x</button>
          </slot>
        </header>
        <section class="modal-body">
          <slot name="body">
            <div v-if="this.loading">
              <div class="d-flex justify-content-center">
                <div class="spinner-grow m-5" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            <div v-else class="p-3">

              <form class="form" @submit.prevent="newTariffGroup" autocomplete="nope">
                <div class="row border-bottom mb-3">
                  <div class="col-3">
                    <div class="form-group">
                      <input class="form-control" type="text" autocomplete="none"
                             id="name" v-model="inputs.name"
                             @focusin="InputFocusIn('name')"
                             @focusout="InputFocusOut('name')"/>
                      <label for="name">Название группы</label>
                    </div>
                  </div>
                  <div class="col-5">
                    <multiselect
                      v-model="inputs.tariffs"
                      :multiple="true"
                      selectLabel=""
                      deselectLabel=""
                      :options="tariffList"
                      :close-on-select="false"
                      :clear-on-select="false"
                      placeholder="Выберите тарифы"
                      label="name"
                      track-by="id">
                      <template slot="selection"
                                slot-scope="{ tariffs, search, isOpen }">
                        <span class="multiselect__single"
                              v-if="inputs.tariffs.length &amp;&amp; !isOpen">
                          {{ inputs.tariffs.length }} тариф выбран
                        </span>
                      </template>
                    </multiselect>
                  </div>
                  <div class="col-4">
                    <button type="submit" class="btn btn-primary">
                       Добавить группу
                     </button>
                  </div>
                </div>
              </form>

              <div v-for="group in tariffGroups" :key="group.id">
                <v-tariff-group-update :group="group" :tariff-list="tariffList"/>
              </div>

            </div>
          </slot>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';
import VTariffGroupUpdate from '../forms/v-tariff-group-update-form.vue';

export default {
  name: 'v-tariff-groups',
  components: { VTariffGroupUpdate, Multiselect },
  data() {
    return {
      inputs: {
        name: '',
        tariffs: '',
      },
      tariffGroups: '',
      tariffGroupId: '',
      loading: true,
      formatTariffs: [],
    };
  },
  computed: {
    ...mapState('tariff', ['tariffGroupList', 'tariffList', 'error']),
  },
  methods: {
    ...mapActions('tariff', ['getTariffList', 'getTariffGroupList', 'createTariffGroup']),
    close() {
      this.$emit('close');
    },
    refactoringTariffs() {
      let i;
      for (i = 0; i < this.inputs.tariffs.length; i += 1) {
        this.formatTariffs.push(this.inputs.tariffs[i].id);
      }
      this.inputs.tariffs = this.formatTariffs;
    },
    newTariffGroup() {
      this.refactoringTariffs();
      this.createTariffGroup(this.inputs)
        .then(() => {
          if (!this.error) {
            this.$notify({
              group: 'message',
              title: 'New message:',
              type: 'success',
              text: 'Новая группа тарифов успешно добавлена!',
            });
          } else {
            this.$notify({
              group: 'message',
              title: 'New message:',
              type: 'error',
              text: 'Произошла ошибка!',
            });
          }
        })
        .finally(() => { this.close(); });
    },
  },
  mounted() {
    this.tariffGroups = this.tariffGroupList;
    this.getTariffList('?get_all=true')
      .then(() => {
        this.loading = false;
      });
  },
};
</script>
